<template>
    <div class="selectContainer">
        <div
          :class="`cursor-pointer displayflex ${border.color} borderWidth1 borderBottomStyleSolid ${border.top ? 'borderTopStyleSolid' : ''}`"
          style="position:relative;min-height:36px;padding:20px 0;"
          @click="openclick=true; dropDownOpen = !dropDownOpen;"
        >
            <div class="displayflex">
              <slot name="close"></slot>

              <div :class="['activeOption', !!this.$slots['close'] ? 'marginleft15' : '', value ? 'fontweight600 colorDarkGrey' : 'colorDarkGrey']">
                  {{value ? value : placeholder}}
              </div>
            </div>

            <!-- <div class="openDropDown" @click="openclick=true; dropDownOpen = !dropDownOpen;">
                <font-awesome-icon :icon="icon" />
            </div> -->
            <SVGIcon
              :name="icon"
              :class="['selfAlignCenter', dropDownOpen ? 'rotate180' :'']"
            />
        </div>

        <ul v-if="dropDownOpen" class="dropDownMenu" v-click-outside="handleOutsideClick">
            <li
            v-for="selectOption in selectOptions"
            :key="selectOption"
            @click="optionClicked(selectOption)"
            >
                <a>{{selectOption}}</a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'Select',
  props: ['selectOptions', 'value', 'placeholder', 'icon', 'border'],
  data: function () {
    return {
      openClick: false,
      dropDownOpen: false
    }
  },
  methods: {
    optionClicked (newActiveLayer) {
      this.dropDownOpen = false
      this.$emit('change', newActiveLayer)
    },
    handleOutsideClick () {
      if (!this.openClick) this.dropDownOpen = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.selectContainer {
  position: relative;
}

.displayflex {
  display: flex;
  justify-content: space-between;
}

.activeOption {
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-self: center;
}

.dropDownMenu {
  position: absolute;
  top: 56px;
  z-index: 1000;
  float: left;
  min-width: 160px;
  width: 100%;

  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 16px;
  text-align: left;
  list-style: none;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);

  max-height: 500px;
  overflow-y: auto;
}
@media (max-width: 768px) {
  .dropDownMenu {
    left: 5px;
  }
}
.dropDownMenu > li > a {
  display: block;
  padding: 3px 20px;
  clear: both;
  font-weight: normal;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  cursor: pointer;
}
.dropDownMenu > li > a:hover {
  background-color: #f5f5f5;
}
</style>
